
export type BookItemType = "app" | "pag" | "txt";



/**
 * Class BookItem.
 *
 * Holds common properties and behaviors to all RuleBook data items.
 */
export class BookItem {

  public kicker: string;
  public title: string;
  public number: string;
  public type: BookItemType;
  public order: number;
  public id: string;
  public parent: string;
  public level: number;
  public children: BookItem[] = [];
  public parents: any[] = [];
  public translated: boolean;

  constructor(rawBookItem: any) {

    if (!rawBookItem) {
      return;
    }

    this.kicker = rawBookItem.kicker;
    this.title = rawBookItem.title;
    this.number = rawBookItem.number;
    this.type = rawBookItem.type;
    this.order = rawBookItem.order;
    this.id = rawBookItem.id;
    this.parent = rawBookItem.parent;
    this.parents = rawBookItem.parents;
    this.level = rawBookItem.level;
    this.translated = rawBookItem.translated === '1';
    this.children = [];
  }

  getFilteredChildren(childrenType: BookItemType): BookItem[] {
    let children: BookItem[] = [];
    if (childrenType) {
      children = this.children.filter(bookItem => bookItem.type == childrenType)
    }
    else {
      // If no filter is supplied return a copy of children array.
      children = this.children.slice(0);
    }
    return children;
  }

  /**
   * Get main parent.
   */
  get mainParent(): BookItem {
    return this.parents.slice(-1).pop();
  }

  /**
   * Get main index.
   *
   * Used to know which book this item is child.
   */
  get mainIndex(): any {
    let id = null;

    let item: any;

    // For inner articles take second parent.
    if (this.parents.length > 1) {
      item = this.parents.slice(-2, -1).pop();
      if (item) {
        id = item.id;
      }
    } else {
      // For first children (so they are books) take themselves.
      id = this.id;
    }

    return id;
  }
}
